'use strict';

/*global services*/
/*global unBlockElement*/

$.ajaxSetup({
  global: true,
  timeout: 120000,
  cache: false,
  error: function () {
    if (services.has('notifications')) {
      services.get('notifications').viewErrorMessage();
    }

    $('.uiBlockerParent').each(function () {
      unBlockElement($(this));
    });
  },

  complete: function (xhr) {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        if (xhr.responseText && xhr.responseText.indexOf('id="login-form"') >= 0) {
          location.reload();
        }
      }
    }
  }
});
